import type { Theme } from '@mui/material/styles';
import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }: { theme: Theme }) => ({
  ipList: {
    overflow: 'hidden',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    height: '40vh !important',
    minHeight: '20rem',
    gap: '0.5rem',
    ul: {
      padding: '0.5rem',
      border: '1px solid var(--mui-palette-border-main)',
      borderRadius: theme.shape.borderRadius,
      flex: 1
    },
    li: {
      backgroundColor: theme.vars.palette.transparent.a10,
      borderRadius: theme.shape.borderRadius,
      marginBottom: '0.25rem'
    }
  },
  ipInput: {
    '.MuiInputBase-root': {
      padding: 0,
      overflowY: 'auto'
    },
    textarea: {
      boxSizing: 'border-box',
      height: '40vh !important',
      padding: '0.5rem',
      minHeight: '20rem'
    }
  }
}));

export default useStyles;
